<template>
  <select
    :value="selectedEstablishmentId"
    name="establishments"
    @change="changeEstablishment($event)"
  >
    <option
      v-for="(establishment, index) in availableEstablishments"
      :key="index"
      :value="establishment.value"
    >
      {{ establishment.text }}
    </option>
  </select>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      establishments: (state) => state.establishments.establishments,
    }),
    availableEstablishments() {
      return this.$store.state.establishments.establishments.map((x) => {
        return { text: `${x.Name} - ${x.City}`, value: x.EstablishmentNumber }
      })
    },
    selectedEstablishmentId() {
      return this.$route.params.establishmentId || this.availableEstablishments[0]?.value || null
    },
  },
  methods: {
    async changeEstablishment(event) {
      let currentRoute = this.$route?.name
      let newRouteName = 'quote-overview-page'
      if (currentRoute?.includes('change-order')) {
        newRouteName = 'change-orders-page'
      } else if (currentRoute?.includes('purchase-order')) {
        newRouteName = 'purchase-orders-page'
      } else if (currentRoute === 'media-page') {
        newRouteName = 'media-page'
      }

      let newRoute = {
        name: newRouteName,
        params: {
          establishmentId: event.target.value,
          cstType: this.$route.params.cstType,
        },
        query: this.$route.query,
        force: true,
      }
      await this.$router.push(newRoute)
    },
  },
}
</script>

<style lang="scss" scoped>
select {
  appearance: none;
  height: 42px;
  max-width: 360px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  background-color: $white;
  padding: 0 38px 0 15px;
  font-size: 0.84rem;
  color: var(--color-text);
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'><path d='M1 3l4 4 4-4' stroke='%23728186' stroke-width='1.4' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 14px center;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    border-color: $gray-light;
  }
  &:focus {
    outline: none;
    border-color: var(--color-primary);
    box-shadow: 0 0 0 3px var(--color-primary-light);
  }
}
</style>
